import React from "react";

export const PageTitle = ({ title }: { title: string }) => {
  return <h1 className="text-4xl font-bold underline m-12">{title}</h1>;
};

export const SectionTitle: React.FC<{ title: string }> = ({ title }) => {
  return <h2 className="text-2xl font-bold underline m-8">{title}</h2>;
};

export const SubSectionTitle: React.FC<{ title: string, align?: 'left' | 'right' }> = ({ title, align = 'left' }) => {
  return <h3 className={`text-xl font-bold m-4 ${align === 'right' ? 'text-right' : 'text-left'}`}>{title}</h3>;
};
